var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_981_72931)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.3335 18.3333C3.3335 16.5652 4.03588 14.8695 5.28612 13.6193C6.53636 12.369 8.23205 11.6667 10.0002 11.6667C11.7683 11.6667 13.464 12.369 14.7142 13.6193C15.9645 14.8695 16.6668 16.5652 16.6668 18.3333H15.0002C15.0002 17.0073 14.4734 15.7355 13.5357 14.7978C12.598 13.8601 11.3262 13.3333 10.0002 13.3333C8.67408 13.3333 7.40231 13.8601 6.46463 14.7978C5.52695 15.7355 5.00016 17.0073 5.00016 18.3333H3.3335ZM10.0002 10.8333C7.23766 10.8333 5.00016 8.59583 5.00016 5.83333C5.00016 3.07083 7.23766 0.833334 10.0002 0.833334C12.7627 0.833334 15.0002 3.07083 15.0002 5.83333C15.0002 8.59583 12.7627 10.8333 10.0002 10.8333ZM10.0002 9.16667C11.8418 9.16667 13.3335 7.675 13.3335 5.83333C13.3335 3.99167 11.8418 2.5 10.0002 2.5C8.1585 2.5 6.66683 3.99167 6.66683 5.83333C6.66683 7.675 8.1585 9.16667 10.0002 9.16667Z",
    fill: "#303030"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_981_72931"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.c881e52e16564f6dd493a8ca68208534.svg";
export { ForwardRef as ReactComponent };